import { kokoroClient } from './kokoroClient';
import { resolveKokoroVoice, isValidKokoroVoiceId } from './voiceMapping';
import type { KokoroVoiceId } from './voiceMapping';
import { uploadKokoroWav } from './uploadKokoroWav';
import { ensureXxhash, parseHexSeed } from './xxhash';
import type {
  KokoroAgentGender,
  KokoroGender,
  KokoroSpeakResult,
} from './types';

export interface SpeakKokoroInput {
  text: string;
  turnId: string | null;
  agentName: string;
  agentGender: KokoroAgentGender;
  defaultGender: KokoroGender;
  pinnedVoiceId: string | null;
  worldSeedHex: string;
}

export async function speakKokoro(
  input: SpeakKokoroInput,
): Promise<KokoroSpeakResult> {
  await ensureXxhash();

  const effectiveGender: KokoroGender =
    input.agentGender === 'default' ? input.defaultGender : input.agentGender;

  let voiceId: KokoroVoiceId;
  if (input.pinnedVoiceId && isValidKokoroVoiceId(input.pinnedVoiceId)) {
    voiceId = input.pinnedVoiceId;
  } else {
    voiceId = resolveKokoroVoice({
      name: input.agentName,
      gender: effectiveGender,
      worldSeed: parseHexSeed(input.worldSeedHex || '0'),
    });
  }

  const { wav, durationMs, sizeBytes } = await kokoroClient.synthesize({
    text: input.text,
    voiceId,
  });

  return uploadKokoroWav({
    wav,
    voiceId,
    text: input.text,
    turnId: input.turnId,
    durationMs,
    sizeBytes,
    agentName: input.agentName,
  });
}
